var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Wizard } from '@juvare/common-form-ui/Wizard';
import { handleErrorDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useAlertClient, useAlertStorageClient, useAlertUiTranslation, useUserState } from '../../../../hooks';
import { useContextData } from '../../../../hooks/useContextData';
import { showTemplateEditDialog } from '../AlertDialog/Utils';
import { FormComponent } from './Components/FormComponent';
import { useAlertWizardSteps } from './WizardSteps/useAlertWizardSteps';
export const AlertWizard = (props) => {
    const { t } = useAlertUiTranslation();
    const contextData = useContextData();
    const steps = useAlertWizardSteps(props.alert, props.mode, props.shouldGenerateUniqueIdentifier).map((step) => ({
        label: step.label,
        render: (wizardProps) => (step.form ? React.createElement(FormComponent, Object.assign({ form: step.form }, wizardProps, { hideFormControls: true })) : null),
    }));
    const handleSubmit = React.useCallback((alertData) => __awaiter(void 0, void 0, void 0, function* () {
        if (props.mode === 'notification') {
            showCustomDialog({
                content: (close) => (React.createElement(ReviewAndSendDialog, { alertData: alertData, userRight: props.userRight, onConfirm: () => {
                        close();
                        props.onSubmit(alertData);
                    }, onCancel: () => {
                        close();
                    } })),
            });
        }
        else {
            props.onSubmit(alertData);
        }
        return Promise.resolve(alertData);
    }), [props.mode]);
    if (!contextData) {
        return React.createElement(React.Fragment, null, "Loading...");
    }
    if (!steps || steps.length === 0) {
        return null;
    }
    return (React.createElement(Wizard, { steps: steps, data: props.alert, onSubmit: handleSubmit, orientation: 'horizontal', onDataChange: props.onDataChange, submitButtonLabel: props.mode === 'notification' ? t('pages.edit.reviewAndSend') : t('common.reviewAndSave'), addFirstStepBack: props.mode === 'notification', firstStepBackButtonLabel: t('common.backToTemplates'), onFirstStepBack: props.onFirstStepBack ? props.onFirstStepBack : () => { } }));
};
const ReviewAndSendDialog = ({ onConfirm, onCancel, alertData, userRight }) => {
    const { t } = useAlertUiTranslation();
    const userState = useUserState();
    const alertClient = useAlertClient();
    const alertStorageClient = useAlertStorageClient();
    const shouldUpdate = userRight === 'write' && (alertData === null || alertData === void 0 ? void 0 : alertData.id);
    const handleSaveOrUpdateAndSend = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!userState || !alertData) {
            return;
        }
        if (shouldUpdate) {
            if (alertData.type !== 'template') {
                alertData.type = 'template';
            }
            try {
                yield alertStorageClient.updateAlert(alertData);
                showAlertSnackbar({
                    message: t('pages.edit.snackbar.template.updated'),
                    type: 'success',
                    autoHideDuration: 1000,
                });
                onConfirm();
            }
            catch (error) {
                onCancel();
                handleErrorDialog(error);
            }
        }
        else {
            showTemplateEditDialog(Object.assign(Object.assign({}, alertData), { id: undefined, title: undefined, icon: undefined, color: undefined, pinned: false, permissions: undefined }), userState, t, alertClient, alertStorageClient, (data) => {
                var _a, _b;
                if ((_a = data.template) === null || _a === void 0 ? void 0 : _a.icon) {
                    alertData.icon = data.template.icon;
                }
                if ((_b = data.template) === null || _b === void 0 ? void 0 : _b.color) {
                    alertData.color = data.template.color;
                }
                onConfirm();
            }, onCancel);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, shouldUpdate ? t('pages.edit.updateTheTemplate') : t('pages.edit.saveAsTemplate')),
        React.createElement(DialogContent, null, shouldUpdate ? (React.createElement(Typography, null, t('pages.edit.updateTemplateDialogText'))) : (React.createElement(Typography, null, t('pages.edit.saveAsTemplateDialogText')))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: onCancel }, t('pages.edit.cancel')),
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: onConfirm }, shouldUpdate ? t('pages.edit.doNotUpdateAndSend') : t('pages.edit.doNotSaveAndSend')),
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: handleSaveOrUpdateAndSend }, shouldUpdate ? t('pages.edit.updateAndSend') : t('pages.edit.saveAndSend')))));
};
